const ActionButtons = ({ text, previewDraft, buttonClass, disabled = false }: any) => {
    const handlePreviewDraftClick = () => {
        previewDraft()
    }

    return (
        <>
            {/* Button */}
            <div className="flex justify-end">
                <button className={` ${buttonClass} !px-5 !py-2.5 !text-sm`} onClick={handlePreviewDraftClick} disabled={disabled}>
                    {text}
                </button>
            </div>
        </>
    )
}

export default ActionButtons;